<template>
    <div class="module">
        <div class="customer-info-item" @click="handleFoldHeader">
            <div class="customer-info-title" @click="handleFold">
                <i class="customer-info-title-icon el-icon-caret-right" :class="{ 'active': active }"></i>
                <span>{{ title }}</span>
            </div>
            <div class="customer-info-button">
                <slot name="operation" />
            </div>
        </div>
        <div class="module-content" v-show="active" :style="contentStyle">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: "bsp-collapsible-module",
        props: {
            title: {
                type: String | Number,
                default: ''
            },
            // 是否点击标题栏展开（折叠）
            clickable: {
                type: Boolean,
                default: true
            },
            // 默认是否展开 true-展开
            isActive: {
                type: Boolean,
                default: true
            },
            contentStyle: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        watch: {
            isActive(val) {
                this.active = val;
            }
        },
        data() {
            return {
                active: this.isActive
            }
        },
        methods: {
            // 点击标题栏
            handleFoldHeader() {
                if (this.clickable) {
                    this.active = !this.active;
                }
            },
            // 点击标题和图标
            handleFold() {
                if (!this.clickable) {
                    this.active = !this.active;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .module {
        margin-bottom: 1px;
    }
    .customer-info-title-icon {
        transition: transform .3s;
        &.active {
            -webkit-transform: rotate(90deg);
            -moz-transform: rotate(90deg);
            -ms-transform: rotate(90deg);
            -o-transform: rotate(90deg);
            transform: rotate(90deg);
        }
    }
    .module-content {
        padding: 10px;
    }
</style>
